"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeState = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// eslint-disable-next-line no-underscore-dangle
global.__redux_recompose_merge = function (state, content) {
  return _objectSpread(_objectSpread({}, state), content);
}; // global.__redux_recompose_merge = (state, content) => state.merge(content);
// This will be exported as configureMergeState at main file


var _default = function _default(modifier) {
  // eslint-disable-next-line no-underscore-dangle
  global.__redux_recompose_merge = modifier;
}; // eslint-disable-next-line no-underscore-dangle


exports["default"] = _default;

var mergeState = function mergeState(state, content) {
  return global.__redux_recompose_merge(state, content);
};

exports.mergeState = mergeState;